import { getBposNavBarData } from 'owa-bpos-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { trace } from 'owa-trace';
import { parse as parseUrl } from 'url';

const SHAREPOINT_BASE_URLS = [
    'https://microsoft.sharepoint.com',
    'https://microsoft-my.sharepoint.com',
    'https://microsoft.sharepoint-df.com',
    'https://microsoft-my.sharepoint-df.com',
];

export default function isSharePointLink(linkUrl: string): boolean {
    const bposNavBarData = getBposNavBarData();
    if (!bposNavBarData) {
        trace.info('isSharePointLink:bposNavBarData is null');
        return false;
    }

    if (isSharePointLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_MySiteHostUrl)) {
        return true;
    }

    if (isSharePointLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_RootSiteUrl)) {
        return true;
    }

    if (isFeatureEnabled('doc-SharePoint-dogfoodUser')) {
        return SHAREPOINT_BASE_URLS.some(url => isSharePointLinkPrefixedWithBaseUrl(linkUrl, url));
    }

    return false;
}

function isSharePointLinkPrefixedWithBaseUrl(linkUrl: string, baseUrl: string): boolean {
    return parseUrl(linkUrl).hostname === parseUrl(baseUrl).hostname && linkUrl !== baseUrl;
}
